import {useNavigate} from 'react-router-dom';

import {CodeEntry} from './codeEntry';

export const CodeEntryContainer = () => {
    const navigate = useNavigate();
    return <CodeEntry onSubmit={(code) => navigate(`/v/${code}`)} />;
};
